<script setup lang="ts"></script>

<template>
  <icon name="lucide:save" />
</template>

<style scoped></style>
